// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605180244/js/" + chunkId + "." + {"44":"0c4d4608","225":"1268e852","481":"6dcf5daa","486":"127ed98e","770":"86b1b5f9"}[chunkId] + ".0.26813972185004054.chunk.js";
};